import { render } from "./KnowledgePage.vue?vue&type=template&id=fa0b9ec2&scoped=true"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"

import "./KnowledgePage.vue?vue&type=style&index=0&id=fa0b9ec2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0b9ec2"]])

export default __exports__